<ng-container>
  <div class="error-container">
    <div class="error-absolute">
      <h1 class="heading-size-2">Sidan kunde inte hittas!</h1>
      <div>Kontrollera att url:en är rätt</div>
    </div>
  </div>
</ng-container>
